<template>
    <div class="wrap btn-position-wrap">
        <div class="client-box">
            <section class="add-user global-section">
                <div class="row">
                    <div class="col-12 form-error" v-if="formError">{{ formError }}</div>
                </div>
                <div class="row">
                    <md-button class="md-icon-button cancel-add-user" @click="cancelAddRelease()">
                        <md-icon>clear</md-icon>
                    </md-button>
                    <div class="col-3">
                        <h2 class="section-title">Add New Build Notes</h2>
                    </div>
                </div>
                <div class="row">
                    <div class="col-4">
                        <md-field class="md-block">
                            <md-input placeholder="Version No." v-model="v_no"></md-input>
                        </md-field>
                    </div>
                    <div class="col-4">
                        <md-field class="md-block">
                            <md-input placeholder="Build Number" v-model="r_no"></md-input>
                        </md-field>
                    </div>
                    <div class="col-4">
                        <md-field class="md-block">
                            <datepicker class="border-0 el" placeholder="Build Date" :format="format" v-model="r_date"></datepicker>
                        </md-field>
                    </div>
                </div>
                <div class="row" v-for="(user, index) in newUsers" :key="index">
                    <div class="col-4">
                        <div class="uploadImgWrapper">
                            <div class="avatar upload s-48 feature-icon-m">
                                <img src="static/img/settings.svg" alt="feature icon" width="34">
                            </div>
                            <div class="client-name-box">
                                <div class="line-item">
                                    <md-field class="md-block">
                                        <md-input v-model="user.functionalityName" placeholder="Functionality Name" @blur="userTouchHanlder(index, 'functionalityName')"></md-input>
                                    </md-field>
                                    <div class="new-user-error" v-if="$v.newUsers.$each[index].functionalityName.$error">Please provide a functionality name for this release functionality.</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-7">
                        <div class="textareaWrapper">
                            <md-field class="md-block boder-0">
                                <textarea class="textareaW" v-model="user.functionalityDesc" placeholder="Description" @blur="userTouchHanlder(index, 'functionalityDesc')"></textarea>
                            </md-field>
                            <div class="new-user-error" v-if="$v.newUsers.$each[index].functionalityDesc.$error">Please provide a description for this release functionality.</div>
                            <md-button v-if="hasMultipleUsers" aria-label="Delete Functionality" class="md-icon-button delete-btn " @click="deleteUser(index)">
                                <md-icon>delete</md-icon>
                            </md-button>
                        </div>
                    </div>
                    <input type="hidden" class="textareaW" :value="user.functionalityDescVer" placeholder="Description"></input>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="bottomBtnWrapper">
                            <div>
                                <div class="">
                                    <md-button class="save-user-button md-primary" aria-label="Add New Client" @click="clickSaveNewRelease()" style="margin-left:1150px">Save</md-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
        <md-dialog :md-click-outside-to-close="false" :md-active.sync="showDialog">
            <div class="user-saving-message">
                <span>
                    <md-progress-spinner class="md-accent user-saving-spinner" :md-diameter="30" md-mode="indeterminate"></md-progress-spinner>
                    Saving Release...
                </span>
            </div>
        </md-dialog>
    </div>
</template>
<script>
import {mapGetters} from 'vuex';
import {required} from 'vuelidate/lib/validators';
import {saveNewRelease, getReleaseDetail} from '../../services/ReleaseService.js';
import Datepicker from 'vuejs-datepicker';

export default {
  data: () => ({
    format: 'MM-dd-yyyy',
    r_no: '',
    r_date: '',
    v_no: '',
    newUsers: [
      {
        functionalityName: null,
        functionalityDesc: null,
        functionalityDescVer: null
      }
    ],
    formError: null,
    showDialog: false
  }),
  components: {
    Datepicker
  },
  computed: {
    ...mapGetters('client', ['clientActive', 'clientList', 'currentClient']),
    ...mapGetters('user', ['userList', 'isAdmin', 'currentUser']),
    hasMultipleUsers () {
      return this.newUsers.length > 1;
    }
  },
  methods: {
    userTouchHanlder (index, key) {
      if (!this.$v.newUsers.$each[index][key].$dirty) {
        this.$v.newUsers.$each[index][key].$touch();
      }
    },
    cancelAddRelease () {
      this.$router.push('/settings/release');
    },
    async loadReleasefunctiondetail (rid) {
      var result = '';
      result = await getReleaseDetail(rid);
      this.releaseDetail = result.data;
    },
    addUser () {
      let newUser = {
        r_no: null,
        r_date: null,
        v_no: null,
        u_id: null,
        functionalityName: null,
        functionalityDesc: null,
        functionalityDescVer: null
      };
      if (this.clientActive) {
        newUser.clientId = this.currentClient.id;
      } else {
        newUser.clientId = null;
      }
      newUser.clientId = [];
      this.newUsers.push(newUser);
    },
    deleteUser (index) {
      if (this.newUsers[index].isPrimaryContact) {
        if (index === 0) {
          this.newUsers[1].isPrimaryContact = true;
        } else {
          this.newUsers[0].isPrimaryContact = true;
        }
      }

      this.newUsers.splice(index, 1);
    },
    async clickSaveNewRelease () {
      this.showDialog = true;
      if (this.r_no === '') {
        this.formError = 'Please enter build number.';
        this.showDialog = false;
      } else if (this.r_date === '') {
        this.formError = 'Please enter build date.';
        this.showDialog = false;
      } else if (this.v_no === '') {
        this.formError = 'Please enter version number.';
        this.showDialog = false;
      } else if (this.newUsers[0].functionalityDesc === '' || this.newUsers[0].functionalityDesc === null || this.newUsers[0].functionalityName === null) {
        this.formError = 'Please enter build notes.';
        this.showDialog = false;
      } else {
        const date = new Date(this.r_date);
        let dateforrequest = date.getFullYear() + '-' +
            ('0' + (date.getMonth() + 1)).slice(-2) + '-' +
            ('0' + date.getDate()).slice(-2);
        this.newUsers[0].r_no = this.r_no;
        this.newUsers[0].r_date = dateforrequest;
        this.newUsers[0].v_no = this.v_no;
        this.newUsers[0].u_id = this.currentUser.id;
        await saveNewRelease(this.newUsers)
          .then(response => {
            this.$router.push('/settings/release');
            this.showDialog = false;
          })
          .catch(error => {
            if (error.response.data.type !== '') {
              this.formError = error.response.data.message;
            }
            this.showDialog = false;
          });
      }
    }
  },
  validations: {
    newUsers: {
      $each: {
        functionalityName: {
          required
        },
        functionalityDesc: {
          required
        },
        clientId: {
          required
        }
      }
    }
  },
  mounted () {
    if (this.clientActive) {
      this.newUsers[0].clientId = this.currentUser.id;
    }
    this.loadReleasefunctiondetail(this.releaseToEdit.id);
  }
};
</script>
<style lang="scss" scoped>
.save-user-button {
    background-color: #00A8CA;
    font-size: 14px !important;
    font-weight: 500;
}

.new-user-error {
    margin-top: -20px;
    font-size: 11px;
    color: red;
}

.form-error {
    font-size: 15px;
    color: red;
}

.add-button button {
    background-color: #00A8CA !important;
    font-size: 14px !important;
    font-weight: 500 !important;
}

.add-button button:hover {
    background-color: #00788A !important;
}

.client-name-box {
    margin-top: 0 !important;
    padding-top: 0 !important;
}

.add-user.global-section {
    margin-top: 30px;
}

.cancel-add-user {
    float: right;
}

.user-saving-message {
    padding: 10px;
    height: 70px;
    margin: auto;

    .user-saving-spinner {
        margin-right: 20px;
    }
}

.showClientList {
    width: 80%;
    float: left;
    margin-left: 8%;
}

#demo {

    height: 150px;
    overflow: auto;
}

.multiple_select {
    width: 20px;
    min-width: 22px;
    height: 20px;
    position: relative;
    border-radius: 2px;
    border: 2px solid transparent;
    cursor: pointer;
}

.line-itemnew {
    width: 150% !important;
}

.textArea-desc-release {
    width: 150% !important;
    height: 100% !important;
}

.avatar-block .delete-btn {
    position: absolute;
    top: 13px;
    right: -272px;
    opacity: 0;
}

.uploadImgWrapper {
    display: flex;
    align-items: center;
}

.uploadImgWrapper .client-name-box {
    display: flex;
    flex: 0 0 84%;
}

.uploadImgWrapper .avatar.upload.s-48.gray {
    display: flex;
    margin-right: 10px;
    flex: 0 0 48px;
}

.textareaWrapper textarea.textareaW {
    width: 100% !important;
    font-size: 16px;
    font-family: inherit;
}

.md-block.boder-0 {
    border: 0 !important;
}

.textareaWrapper {
    position: relative;
}

.md-icon-button.delete-btn {
    position: absolute;
    right: -60px;
    top: 10px;
}

.bottomBtnWrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.feature-icon-m {
    padding: 5px;
}

</style>



// WEBPACK FOOTER //
// src/components/client/AddRelease.vue